<template>
  <div class="my-pagination">
    <el-pagination
      :current-page="page.cur_page"
      :page-size="page.page_size"
      :total="page.total_num"
      :page-sizes="pageSizes"
      :layout="layout"
      :background="background"
      :disabled="disabled"
      v-bind="$attrs"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script setup>
defineOptions({ inheritAttrs: false })

// 分页对象结构（与接口返回 page 字段一致）：{ cur_page, page_size, total_num, total_page }
// 采用受控 v-model:page 绑定整个对象，同一页面多实例传入各自对象，天然互不干扰
const props = defineProps({
  page: {
    type: Object,
    default: () => ({ cur_page: 1, page_size: 10, total_num: 0, total_page: 0 })
  },
  pageSizes: { type: Array, default: () => [10, 20, 30, 50] },
  layout: { type: String, default: 'prev, pager, next, jumper, total' },
  background: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['update:page', 'change'])

const handleCurrentChange = (cur) => {
  const next = { ...props.page, cur_page: cur }
  emit('update:page', next)
  emit('change', next)
}

const handleSizeChange = (size) => {
  // 每页条数变化时自动重置回第 1 页
  const next = { ...props.page, page_size: size, cur_page: 1 }
  emit('update:page', next)
  emit('change', next)
}
</script>

<style lang="less" scoped>
.my-pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;

  :deep(.el-pagination) {
    // Element Plus 默认 16px，压缩到 8px，保持清晰分组但减少松散感
    --el-pagination-item-gap: 8px;
    max-width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
    row-gap: 8px;
  }

  :deep(.el-pagination__sizes .el-select) {
    width: 112px;
  }

  :deep(.el-pagination__editor.el-input) {
    width: 48px;
  }

  :deep(.el-pagination__goto) {
    margin-right: 6px;
  }

  :deep(.el-pagination__classifier) {
    margin-left: 6px;
  }
}
</style>
